export default __webpack_public_path__ + "static/logo-d6f4ce44de463351a3f54dc76c958ec1.png";